export default __webpack_public_path__ + "static/6859-6b03ac6e0bf9600cc879c1b31855e01f.jpg";